module.exports = {"id":"167575","name":"Anton Shunin","rating":"73","photo":"./data/images/photos/4/167575.png","club":{"name":"Dynamo Moscou","logo":"./data/images/clubs/DynamoMoscou.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AntonShunin0.json
// module id = 434
// module chunks = 0